import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {FormService} from "../../services/form.service";
import {distinctUntilChanged, map} from "rxjs/operators";
import {Subscription} from "rxjs";
import {BinaryQuestionData} from "../../../store/actions/order.actions";

@Component({
    selector: 'binary-question-with-comment',
    templateUrl: './binary-question-with-comment.template.html',
    styleUrls: ['./binary-question-with-comment.style.scss'],
    standalone: false
})
export class BinaryQuestionWithCommentComponent implements OnInit, OnDestroy {

	@Input() binaryQuestionHtmlID: string;
	@Input() binaryQuestionControlName: string;
	@Input() textAreaHtmlID: string;
	@Input() textAreaControlName: string;
	@Input() question: BinaryQuestionData;
	@Input() textAreaPlaceHolder: string;
	@Input() formKey: string;
	@Input() form: FormGroup;
	@Input() formService: FormService;
	@Input() autoGrowEnabled: boolean;

	textAreaVisible: boolean;
	private subscription: Subscription;

	constructor(private changeDet: ChangeDetectorRef) {
	}

	ngOnInit(): void {
		this.textAreaVisible = this.shouldTextAreaBeVisible(this.formService.getFormControl(this.formKey, this.binaryQuestionControlName).value);

		this.subscription = this.formService.onValueChange<boolean>(this.binaryQuestionControlName, this.formKey).pipe(
			distinctUntilChanged(),
			map((value: boolean) => this.shouldTextAreaBeVisible(value)),
		).subscribe(value => {
			this.textAreaVisible = value;
			this.changeDet.detectChanges();
		});
	}

	private shouldTextAreaBeVisible(answer: boolean): boolean {
		return (this.question.commentMandatory == null || this.question.commentMandatory) && this.question.commentMandatoryWithAnswerValueEqualTo != null && answer != null &&
			answer === this.question.commentMandatoryWithAnswerValueEqualTo;
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
